import {
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Box,
    Typography,
    Paper,
    Divider,
    Select,
    IconButton,
    Button,
    MenuItem,
    Menu,
    Stack,
    Pagination,
    PaginationItem,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import Switch from "@mui/material/Switch";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import EditButton from "../../../assets/icons/EditButton.svg";
import TrashButton from "../../../assets/icons/TrashButton.svg";
import EyeIcon from "../../../assets/icons/EyeIcon.svg";
import ActiveAddButton from "../../../assets/icons/ActiveAddButton.svg";
import ArrowDown from "../../../assets/icons/ArrowDown.svg";
import React, { useState } from "react";
import BackArrow from "../../../assets/icons/BackArrow.svg";
import CalanderActive from "../../../assets/icons/CalanderActive.svg";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import moment from "moment";
import { DateEditCalendar } from "../../CommonComponent/DateEditCalendar";
import CircularProgress from "@mui/material/CircularProgress";
//   import ScreenAccessMasterModel from "./AddScreenAccessMasterModel";
import {
    updateScreenAccessMasterList,
    deleteScreenAccessMastersList,
} from "../../../redux/actions/mastersAction";
import AddDefectMasterModel from "./AddDefectMasterModel";
import EditDefectMasterModel from "./EditDefectMasterModel";
import DeleteModel from "../../CommonComponent/DeleteModel";
//   import AddScreenAccessMasterModel from "./AddScreenAccessMasterModel";


const AntSwitch = styled(Switch)(({ theme }) => ({
    width: 28,
    height: 16,
    padding: 0,
    display: "flex",
    "&:active": {
        "& .MuiSwitch-thumb": {
            width: 15,
        },
        "& .MuiSwitch-switchBase.Mui-checked": {
            transform: "translateX(9px)",
        },
    },
    "& .MuiSwitch-switchBase": {
        padding: 2,
        "&.Mui-checked": {
            transform: "translateX(12px)",
            color: "#fff",
            "& + .MuiSwitch-track": {
                opacity: 1,
                backgroundColor: theme.palette.mode === "dark" ? "#26875C" : "#26875C",
            },
        },
    },
    "& .MuiSwitch-thumb": {
        boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
        width: 12,
        height: 12,
        borderRadius: 6,
        transition: theme.transitions.create(["width"], {
            duration: 200,
        }),
    },
    "& .MuiSwitch-track": {
        borderRadius: 16 / 2,
        opacity: 1,
        backgroundColor:
            theme.palette.mode === "dark"
                ? "rgba(255,255,255,.35)"
                : "rgba(0,0,0,.25)",
        boxSizing: "border-box",
    },
}));

const DefectMasterContent = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const isLoading = useSelector((state) => state?.user?.isLoading);

    const [isAddDefectMaster, setIsAddDefectMaster] = useState(false);
    const [isEditDefectMaster, setIsEditDefectMaster] = useState(false);
    const [isPaginationLimit, setIsPaginationLimit] = useState("")
    const [isdeleteModel, setIsdeleteModel] = useState(false);

    const handleChangeIsPaginationLimit = (event) => {
        setIsPaginationLimit(event.target.value);
    };

    const handleCloseAddDefectMaster = (e) => {
        setIsAddDefectMaster(false);
    };

    const handleCloseEditDefectMaster = (e) => {
        setIsEditDefectMaster(false);
    };


    const toggleActiveStatus = (Screenrow) => {
        dispatch(
            updateScreenAccessMasterList({
                id: Screenrow?.id,
                active: !Screenrow?.active,
            })
        );
    };



    const DefectMaster = [
        {
            question: "Question"
        }
    ]

    const handleClosedeleteModel = (e) => {
        setIsdeleteModel(false);
    };

    {
        isdeleteModel && (
            <DeleteModel
                isdeleteModel={isdeleteModel}
                handleClosedeleteModel={handleClosedeleteModel}
            // handleDelete={handleDelete}
            />
        )
    }

    return (
        <>
            {isAddDefectMaster && (
                <AddDefectMasterModel
                    isAddDefectMaster={isAddDefectMaster}
                    handleCloseAddDefectMaster={handleCloseAddDefectMaster}
                />
            )}
            {isEditDefectMaster && (
                <EditDefectMasterModel
                    isEditDefectMaster={isEditDefectMaster}
                    handleCloseEditDefectMaster={handleCloseEditDefectMaster}
                />
            )}
            {isdeleteModel && (
                <DeleteModel
                    isdeleteModel={isdeleteModel}
                    handleClosedeleteModel={handleClosedeleteModel}
                // handleDelete={handleDelete}
                />
            )}
            <Paper
                sx={{
                    width: "auto",
                    height: "auto",
                    overflow: "auto",
                    borderRadius: "10px",
                }}
            >
                <Box
                    sx={{
                        height: "80px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: "20px",
                        overflow: "auto",
                        width: "auto",
                        "&::-webkit-scrollbar": {
                            width: "5px",
                            height: "3px",
                        },
                        "&::-webkit-scrollbar-thumb": {
                            backgroundColor: "#20724E",
                            borderRadius: "4px",
                        },
                        "&::-webkit-scrollbar-track": {
                            backgroundColor: "#E5F1EB",
                        },
                    }}
                >
                    <Box sx={{ display: "flex" }}>
                        <Box
                            sx={{
                                display: "flex",
                                ml: 2,
                                alignItems: "center",
                                cursor: "pointer",
                            }}
                            onClick={() => {
                                navigate("/masters");
                            }}
                        >
                            <img src={BackArrow} alt="" width="17" height="17" />
                        </Box>
                        <Box>
                            <Typography
                                sx={{
                                    ml: 1,
                                    fontSize: "18px",
                                    fontWeight: 600,
                                    color: "#212121",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                }}
                            >
                                Defect Master
                            </Typography>
                        </Box>
                    </Box>

                    <Box sx={{ display: "flex" }}>
                        <Box
                            sx={{ display: "flex", alignItems: "center", gap: "10px", mr: 2 }}
                        >
                            <Button
                                variant="outlined"
                                sx={{
                                    fontSize: "15px",
                                    fontWeight: 600,
                                    borderColor: "#26875C",
                                    width: "6rem",
                                    backgroundColor: "FFFFFF",
                                    padding: "6px 0px 4px 0px",
                                    borderRadius: "10px",
                                    textTransform: "capitalize",
                                    color: "#26875C",
                                    ":hover": {
                                        borderColor: "#26875C",
                                    },
                                }}
                                onClick={() => setIsAddDefectMaster(true)}
                            >
                                <Box sx={{ marginRight: "10px" }}>
                                    <img src={ActiveAddButton} alt="" />
                                </Box>
                                Add
                            </Button>
                        </Box>
                    </Box>
                </Box>
                <Divider sx={{ width: "auto" }} />

                <Box sx={{ margin: "10px 25px 20px 25px" }}>
                    <TableContainer
                        sx={{
                            maxHeight: "620px",
                            "&::-webkit-scrollbar": {
                                width: "5px",
                                height: "3px",
                            },
                            "&::-webkit-scrollbar-thumb": {
                                backgroundColor: "#20724E",
                                borderRadius: "4px",
                            },
                            "&::-webkit-scrollbar-track": {
                                backgroundColor: "#E5F1EB",
                            },
                        }}
                    >
                        <Table stickyHeader>
                            <TableHead>
                                <TableRow>
                                    <TableCell
                                        sx={{
                                            color: "#B5B5C3",
                                            fontWeight: 600,
                                            whiteSpace: "flex"
                                        }}
                                    >
                                        Question
                                    </TableCell>
                                    <TableCell></TableCell>
                                    <TableCell
                                        sx={{
                                            display: "flex",
                                            justifyContent: "flex-end",
                                            color: "#B5B5C3",
                                            fontWeight: 600,
                                            whiteSpace: "flex"
                                        }}
                                    >
                                        Action
                                    </TableCell>
                                </TableRow>
                            </TableHead>

                            {isLoading ? (
                                <TableBody>
                                    <TableRow
                                        sx={{
                                            "&:last-child td, &:last-child th": { border: 0 },
                                            height: "10rem",
                                        }}
                                    >
                                        <TableCell colSpan={8} align="center">
                                            <CircularProgress color="success" />
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            ) : (
                                <TableBody>
                                    {DefectMaster.map((row, index) => (
                                        <TableRow key={row.id}>
                                            <TableCell sx={{ color: "#464E5F", fontWeight: "600" }}>
                                                {row?.question}
                                            </TableCell>
                                            <TableCell></TableCell>
                                            <TableCell
                                                sx={{
                                                    display: "flex",
                                                    justifyContent: "flex-end",
                                                    color: "#B5B5C3",
                                                    fontWeight: 600,
                                                    whiteSpace: "flex"
                                                }}
                                            >
                                                <IconButton>
                                                    <img onClick={() => setIsEditDefectMaster(true)} src={EditButton} width="30" height="30" alt="Edit" />
                                                </IconButton>
                                                <IconButton>
                                                    <img onClick={() => {
                                                        // setManagementDeleteID(row?.id);
                                                        setIsdeleteModel(true);
                                                    }} src={TrashButton} width="30" height="30" alt="Delete" />
                                                </IconButton>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            )}
                        </Table>
                    </TableContainer>
                    <Divider />
                    {DefectMaster.length > 0 && (
                        <Stack
                            spacing={2}
                            direction="row"
                            justifyContent="flex-end"
                            alignItems="center"
                            sx={{
                                padding: "1rem",
                                marginTop: "10px",
                            }}
                        >
                            <Box sx={{
                                display: "flex",
                                alignItems: "center"
                            }}>
                                <Typography sx={{ mr: "8px" }}>Row Per Page</Typography>
                                <Select
                                    value={isPaginationLimit}
                                    onChange={handleChangeIsPaginationLimit}
                                    displayEmpty
                                    inputProps={{ "aria-label": "Without label" }}
                                    IconComponent={() => (
                                        <Box
                                            sx={{
                                                marginRight: "10px",
                                                display: "flex",
                                                alignItems: "center",
                                            }}
                                        >
                                            <img
                                                src={ArrowDown}
                                                alt="Custom Icon"
                                                width="18"
                                                height="24"
                                            />
                                        </Box>
                                    )}
                                    sx={{
                                        height: "37px",
                                        width: "6rem",
                                        color: "#20724E",
                                        fontWeight: "bold",
                                        borderRadius: "10px",
                                        border: "none",
                                        backgroundColor: "#E5F1EB",
                                        mr: 2,
                                        "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                                            border: "1px solid #E5F1EB",
                                        },
                                        "& .MuiOutlinedInput-notchedOutline": {
                                            border: "none",
                                        },
                                    }}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                >
                                    <MenuItem value="">10</MenuItem>
                                    <MenuItem value={10}>20</MenuItem>
                                    <MenuItem value={20}>30</MenuItem>
                                </Select>
                            </Box>
                            <Box>
                                <Pagination
                                    count={10}
                                    renderItem={(item) => (
                                        <PaginationItem
                                            slots={{
                                                previous: ArrowBackIcon,
                                                next: ArrowForwardIcon,
                                            }}
                                            {...item}
                                        />
                                    )}
                                />
                            </Box>
                        </Stack>
                    )}
                </Box>
            </Paper>
        </>
    );
};

export default DefectMasterContent;
